<style>
.Account_Type {
    max-width: 1540px;
    width: 100%;
}

.users_top li {
    padding: 20px;
}

.Account_Type .users_top {
    display: flex;
    border-bottom: 5px solid #006bff;
    background: #FFF;
    justify-content: space-between;
}

.Account_Type .users_top li {
    max-width: 256px;
    width: 100%;
    padding: 20px 20px 15px;
    background: #FFF;
    box-sizing: border-box;
}

.Account_Type .users_top .total_ftd {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.Account_Type .users_top .total_ftd .total_ftd_right {
    display: flex;
    align-items: center;
}

.Account_Type .users_top .total_ftd .total_ftd_left span {
    font-size: 16px;
}

.Account_Type .users_top .total_ftd .total_ftd_right span {
    font-size: 14px;
    color: #1DD1A1;
}

.Account_Type .users_top .total_ftd .total_ftd_right img {
    width: 24px;
    height: 24px;
}

.Account_Type .users_top li h3 {
    font-size: 30px;
    color: #000;
    line-height: 1.367;
    padding-bottom: 20px;
}

.Account_Type .users_top li p {
    font-size: 14px;
    color: #898787;
}

.Account_Type .users_top li h4 {
    font-size: 16px;
    color: #000;
}
.pie_chart {
    max-width: 551px;
    width: 100%;
    box-sizing: border-box;
    background-color: #fff;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 40px 75px;
}

.Number {
    padding-bottom: 24px;
}

.Number h2 {
    font-size: 16px;
    color: #000;
    text-align: center;
    line-height: 1.375;
    padding-bottom: 20px;
}

.Number ul {
    display: flex;
    column-gap: 30px;
    row-gap: 10px;
    flex-wrap: wrap;
    justify-content: center;
}

.Number ul li {
    max-width: 120px;
    width: 100%;
    padding-left: 10px;
    border-left: 5px solid #006BFF;
}

.Account_usersamt {
    width: 100%;
    padding: 9px 20px;
    display: flex;
    gap: 20px;
    background: #FFF;
    margin-bottom: 1px;
    box-sizing: border-box;
}

.Account_usersamt div {
    max-width: 140px;
    width: 100%;
    font-size: 14px;
    background-color: #ebf4ff;
    border-radius: 50%;
    border-radius: 50px;
    text-align: center;
    line-height: 1.429;
    color: #232020;
    cursor: pointer;
    box-sizing: border-box;
}

.computer_smartphone {
    display: flex;
    justify-content: space-around;
}

.computer_smartphone div,
.Ftd_computer {
    display: flex;
    align-items: center;
    gap: 7px;
}

.Ftd_computer span {
    color: #BBBABA;
}

.Account_usersamt a {
    padding: 5px 15px;
    box-sizing: border-box;
    display: block;
    max-width: 140px;
    width: 100%;
    color: #232020;
}

.Account_actived {
    background-color: #006BFF !important;
    color: #FFFFFF !important;
}

.Account_actived a {
    color: #FFFFFF !important;
}

.traffic_view {
    position: relative;
}

.trend_load {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #ffffff;
}

.el-icon-loading {
    font-size: 50px;
}

.domain_name {
    padding: 10px 0;
}
</style>
<template>
    <div class="Account_Type">
        <div class="Account_usersamt">
            <div v-for="(item, index) in Account_Type_roter" :key="index" @click=" usersamt(index)">
                <router-link :to="item.url">
                    <span>{{ item.name }}</span>
                </router-link>
            </div>
        </div>
        <div class="domain_name">
            <el-select v-model="traffic" placeholder="请选择">
                <el-option v-for="item in traffic_options" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
            </el-select>
        </div>
        <div class="traffic_view">
            <router-view></router-view>
        </div>
    </div>
</template>
<script>
import $ from 'jquery'
import cookies from 'js-cookie'
export default {
    data () {
        return {
            Account_usersamt: 0,
            Account_Type_roter: [
                { name: "Trend", url: "/Dashboard/Traffic/Trend", },
                { name: "Channels", url: "/Dashboard/Traffic/Channels", },
                { name: "Country", url: "/Dashboard/Traffic/Country", },
            ],
            traffic: 'Select domain',
            traffic_options: [
                {label:"All",
                value:"",},
            ],
        }
    },
    mounted () {
        this.getDatas()
        this.Account_usersamt = sessionStorage.getItem("Cookies_Account_usersamt")
        // console.log(this.Account_usersamt, "sdgasdfg")
        if (this.Account_usersamt != "undefined") {
            $(".Account_usersamt div span").eq(this.Account_usersamt).parent().parent().addClass("Account_actived").siblings().removeClass("Account_actived")
        } else {
            $(".Account_usersamt div span").eq(0).parent().parent().addClass("Account_actived").siblings().removeClass("Account_actived")
        }
        window.onbeforeunload = function () {
            //清除sessionStorage值
            sessionStorage.removeItem('traffic')

        }
    },
    watch: {
        'traffic' (newName, oldName) {
            if (newName != "") {
                sessionStorage.setItem("traffic", this.traffic)
            } else {
                sessionStorage.removeItem('traffic')
            }
        },
    },
    methods: {
        usersamt (e) {
            $(".Account_usersamt div span").eq(e).parent().parent().addClass("Account_actived").siblings().removeClass("Account_actived")
            sessionStorage.setItem("Cookies_Account_usersamt", e)
        },
        getDatas () {
            let this_f = this
            $.ajax({
                type: "get",
                url: "https://google-analytics-test.canglankeji.com/api/traffic/search_domain",
                headers: {
                    Authorization: "Bearer " + cookies.get("token"),
                },
                dataType: 'json',
                success: function (res) {
                    for (let index = 0; index < res.result.length; index++) {
                        this_f.traffic_options.push({
                            value: res.result[index],
                            label: res.result[index],
                        })
                    }
                    console.log(this_f.traffic_options)
                }
            })
        }
    },
    beforeDestroy () {
        sessionStorage.setItem("Cookies_Account_usersamt", "undefined")
    }
}
</script>



// WEBPACK FOOTER //
// src/views/Traffic.vue